import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=15b4ecdf&scoped=true"
import script from "./LabelInput.vue?vue&type=script&lang=js"
export * from "./LabelInput.vue?vue&type=script&lang=js"
import style0 from "./LabelInput.vue?vue&type=style&index=0&id=15b4ecdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4ecdf",
  null
  
)

export default component.exports